<template>
  <div v-if="recommendedVenues.length" class="has-background-white-ter pt-1">
    <div class="featured-header mx-1-half ">
      <h3
        class="title is-size-18px"
      > 
      {{ railHeader }}
      </h3>
    </div>
    <div style="margin-top: 8px">
      <div class="is-rail py-0 pl-1">
        <template v-for="venue in recommendedVenues">
          <div class="venue-card has-background-white" :key="venue.id">
            <router-link
              tag="div"
              :to="{ name: 'venue-view', params: { venueID: venue.id}}"
              class="venue-logo"
            >
              <figure class="image">
                <img
                  class="is-rounded"
                  lazy="loaded"
                  v-lazy="venue.data.userImagePaths.avatarURLs[0]"
                  :alt="venue.data.displayName"
                />
              </figure>
            </router-link>
            <!-- @click.native="$store.commit('appData/SET_DISPLAYED_VENUE_NAME', event.data.eventVenueName)" -->
            <router-link
              tag="div"
              :to="{ name: 'venue-view', params: { venueID: venue.id}}"
              style="padding: 0 8px; "
              class="venue-name is-size-14px has-text-weight-medium has-text-black-bis has-text-centered"
            >{{ venue.data.displayName }}</router-link>
            <div style="margin: 16px 8px 4px 8px">
              <button
                @click="addToUserFollowings(venue)"
                class="button is-small is-link is-fullwidth has-text-weight-medium"
              >{{ followingsList.find(v => v.id === venue.id) ? $t('ui.following') : $t('ui.follow')}}</button>
            </div>
          </div>
        </template>

        <div class="is-rail-end-gap"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { followOperations } from "@/mixins/follow";
import { mapGetters } from "vuex";

export default {
  name: "card-rail-venue",
  mixins: [followOperations],
  props: {
    venueType: {
      type: String,
      required: true
    },
    railHeader: {
      type: String,
      default: '',
    },
    venueId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      recommendedVenues: [],
      followingsList: []
    };
  },
  watch: {
    userDoc(val) {
      if (val) {
        this.fetchRecommendedVenues()
      }
    }
  },
  computed: {
    ...mapGetters({
      userDoc: "user/userDoc"
    })
  },
  created() {
    if (this.userDoc) {
      this.fetchRecommendedVenues();
    }
  },
  methods: {
    async fetchRecommendedVenues() {
      try {
        const venues = await this.$store.dispatch(
          "appData/fetchRecommendedVenues",
          { venueType: this.venueType }
        );
        // this.selectedVenue = venues[0].id;
        // console.log('venues methods', venues);
        this.recommendedVenues = venues.sort(() => 0.5 - Math.random());

        if (this.venueId) {
          this.recommendedVenues = this.recommendedVenues.filter(i => i.id !== this.venueId)
        }

        // set followings list
        this.recommendedVenues.forEach(venue => {
          const inList = this.userDoc.follows.followings.find(
            v => v.userID === venue.id
          );
          if (inList) this.followingsList.push(venue);
        });

        // console.log("FOLLOWING LIST", this.followingsList);
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.log(error);
        }
      }
    },
    addToUserFollowings(user) {
      if (!this.$store.state.user.authUser.isAnonymous) {
        if (this.followingsList.find(v => v.id === user.id)) {
          this.arrayRemove(user);
        } else {
          this.followingsList.push(user);
        }
      }

      const followed = false;
      const { isUserFollowed, userFollowersCount } = this.followAUserMixin(
        user,
        followed
      );
    },
    arrayRemove(venue) {
      this.followingsList = this.followingsList.filter(function(ele) {
        // console.log('arr', ele.key, 'value', value.key)
        return ele.id != venue.id;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.venue-card {
  width: 132px;
  min-width: 132px;
  margin: 0 2px !important;
  border: 1px solid $grey-lighter;
  border-radius: 4px;
  // padding: 0;
}
.venue-card:first-child {
  margin-left: 0 !important;
}
.venue-logo {
  // width: 48px;
  padding-top: 0.25rem;
  width: 100%;
}

.venue-logo .image {
  // border: 1px solid $info;
  border-radius: 50%;
  height: 72px;
  margin: 0 auto;
  width: 72px;
  padding: 4px;
}

.venue-logo .image.is-active {
  border: 2px solid $link;
  padding: 2px;
}

.venue-logo .image img {
  border: 1px solid $grey-lighter;
  border-radius: 50%;
}

.is-rail .venue-card {
  position: relative;
  padding: 0.25rem 0;
  display: inline-block;
  margin: 0 0;
  opacity: 0.8;
}
.venue-name {
  margin-top: 4px;
  min-height: 36px;

  white-space: pre-wrap;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>